import { memo } from 'react';
import BookingGridBase from '../common/BookingGridBase';
import BookingCardPixelv2 from './BookingCardPixelv2';

function GridPixel({
  bookings,
  rowCount,
  date,
  slotCapacity,
  updateBooking,
  handleOpenModal,
  capacity,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  draggedBookingDuration,
  isShiftable,
  isLoadingShiftTimes,
}) {
  const calcAttendance = bookingsList => {
    let times = Array.from({ length: (24 - 9) * 2 + 1 }, (_, index) => {
      const stunde = 9 + Math.floor(index / 2);
      const minuten = index % 2 === 0 ? '00' : '30';
      return {
        isFull: index % 2 === 0,
        time: `${stunde}:${minuten}`,
        qualifiedTime: new Date(
          date.get('year'),
          date.get('month'),
          date.get('date'),
          stunde,
          minuten
        ),
        i: index,
        s0: 0,
        frees0: slotCapacity,
      };
    });

    for (const booking of bookingsList) {
      const { bookingType } = booking;
      const isBlocker = booking.status === 'blocked';
      const startKey = bookingType === 'RegiondoBooking' ? 'eventStart' : 'startTime';
      const endKey = bookingType === 'RegiondoBooking' ? 'eventEnd' : 'endTime';
      const compStart = new Date(booking[startKey]);
      const compEnd = new Date(booking[endKey]);
      const participantCount = Number(booking.participantCount || 0);
      const densityRaw = Number(entertainment?.participantLaneDensity || 0);
      const occupiedUnits =
        Number.isFinite(densityRaw) && densityRaw > 0
          ? Math.ceil(participantCount / densityRaw)
          : participantCount > 0
            ? 1
            : 0;

      for (let timeslot of times) {
        if (compStart <= timeslot.qualifiedTime && compEnd > timeslot.qualifiedTime && occupiedUnits > 0) {
          if (!isBlocker) {
            timeslot.s0 += occupiedUnits;
          }
          timeslot.frees0 -= occupiedUnits;
        }
      }
    }

    return times;
  };

  return (
    <BookingGridBase
      bookings={bookings}
      rowCount={rowCount}
      date={date}
      slotCapacity={slotCapacity}
      calcAttendance={calcAttendance}
      capacityData={capacity}
      availableShiftTimes={availableShiftTimes}
      draggedBookingDuration={draggedBookingDuration}
      isShiftable={isShiftable}
      isLoadingShiftTimes={isLoadingShiftTimes}
      renderBookingCard={(booking, idx, rowHeight) => (
        <BookingCardPixelv2
          key={booking._id}
          booking={booking}
          updateBookingState={updateBooking}
          handleOpenModal={handleOpenModal}
          renderAvailableSlots={false}
          rowHeight={rowHeight}
          onBookingShift={onBookingShift}
          entertainment={entertainment}
          onDragStart={onDragStart}
          onDragActivated={onDragActivated}
          onDragEnd={onDragEnd}
          availableShiftTimes={availableShiftTimes}
          isShiftable={isShiftable}
        />
      )}
      renderAvailableSlots={false}
    />
  );
}

export default memo(GridPixel);
